<div class="filter-group">
  <div class="filter-group__header">
    <div class="filter-group__title">
      {{ 'filters.category.main.label' | i18n }}
    </div>

    <button
      class="filter-group__reset"
      *ngIf="canReset"
      (click)="resetCategory()"
    >
      {{ 'filters.common.reset' | i18n }}
    </button>
  </div>

  <div class="filter-group__main">
    <lib-standard-dropdown
      [options]="categoryOptions"
      [currentOption]="currentCategoryOption"
      [defaultOption]="categoryOptions[0]"
      (update)="onChange($event)"
    >
    </lib-standard-dropdown>
  </div>
</div>
